module.exports = __webpack_public_path__ + "img/ssyx_06.8f4f100c.jpg";